import { useQuery } from '@tanstack/vue-query'
import { investorsQueryKeys } from '../investorsQueryKeys'
import { getKycExpiredStatusCounts } from '../investorsEndpoints'

export function useKycExpiredStatusCountsQuery() {
  return useQuery({
    queryKey: investorsQueryKeys.kycExpiredStatusCounts(),
    queryFn: getKycExpiredStatusCounts,
    staleTime: 1000 * 30,
  })
}
